"use strict";
'use client';
exports.__esModule = true;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var default_1 = tslib_1.__importDefault(require("./default"));
var simple_1 = tslib_1.__importDefault(require("./simple"));
var DataTable = function (props) {
    if (props.variant === 'default') {
        return (0, jsx_runtime_1.jsx)(default_1["default"], tslib_1.__assign({}, props));
    }
    return (0, jsx_runtime_1.jsx)(simple_1["default"], tslib_1.__assign({}, props));
};
exports["default"] = DataTable;
//# sourceMappingURL=data-table.js.map